import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ReplaySubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { IssueFileAudit } from '../../../classes';
import { IIssueAuditWrapperProvider, ISSUE_AUDIT_WRAPPER_PROVIDER } from '../../../interfaces';

@Component({
  selector: 'app-issue-audit-files',
  templateUrl: './issue-audit-files.component.html',
  styleUrls: ['./issue-audit-files.component.css']
})
export class IssueAuditFilesComponent implements OnDestroy, OnInit {

  private _audit = new ReplaySubject<IssueFileAudit[]>();
  @Input() set issueFileAudit(audit: IssueFileAudit[]){
    this._audit.next(audit);
  }

  createdFiles$ = this._audit.pipe(map(x => x.filter(y => y.action === 0)));
  movedFiles$ = this._audit.pipe(map(x => x.filter(y => y.action === 1)));
  deletedFiles$ = this._audit.pipe(map(x => x.filter(y => y.action === 2)));

  private _subscriptions: Subscription[] = [];

  constructor(
    @Inject(ISSUE_AUDIT_WRAPPER_PROVIDER) private _issueAuditWrapperProvider: IIssueAuditWrapperProvider
  ) { }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      this._issueAuditWrapperProvider.issueAuditWrapper$.subscribe((wrapper) => this.issueFileAudit = wrapper.issueFileAudit)
    ]);
  }

}
